$(document).ready(function() {
	if(!document.querySelector('.chat-and-email')) return false;
    
	var chatEmail = {
		el: $('.chat-and-email'),
		countryCode: $('html').data('countrycode'),
		init: function() {
			chatEmail.addEvent();
		},
		addEvent: function(){
			if (chatEmail.countryCode === 'es') {
				$('a[data-link-name="chat"]').click(function(e){
					if ($('#chatEmailAgree').checkValidation()) {
						window.Inbenta.openChatbot();
					}
				});
			}
			
			// LGECS-229 start
			// adobe
			$('.chat-and-email #zendesk-button').on('click', function() {
				adobeTrackEvent('cs-lg-chatbot-start-btn', {page_event : {start_lg_chatbot : true}});
			});
			// LGECS-229 end
		}
	};
	chatEmail.init();
});